import {USD} from "@dinero.js/currencies";

export const generalConfig = {
    currency: USD,
    currencyRegEx: /^\d{1,3}(?:,\d{3})*(\.\d+)?$/
}